import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { PackingMachine } from './packing-machine';
import { PackingOrder } from './packing-order';
import { PackingProcessStep } from './packing-process-step';

export class PackingOrderStep extends BaseEntity {

  	id              		: number;
	packingOrder  			: PackingOrder ;
	packingProcessStep 		: PackingProcessStep;
	packingMachine  		: PackingMachine;
	rank					: number ;
	quantity				: number ;


  constructor() {
    super();

  }
}

	
